export const getMobileDetailDownloadTitle = function (
  pipeStart?: any,
  metrics?: any[],
  pipeInLoop?: any,
  pipeEnd?: any,
) {
  const title: any[] = [];
  pipeStart?.(title);
  // 指标
  metrics?.forEach((item) => {
    pipeInLoop?.({
      item,
      metricTitle: '',
      title,
    });
  });
  pipeEnd?.(title);
  return title;
};
